import React, { useRef,useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setProjects} from '../actions'
import Project from './Project'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function Projects() {
  const resumeProjects=useSelector(states=>states.resumeData).projects
  const [projects,setResumeProjects]=useState(()=>{
    return resumeProjects
  })
  const dispatch=useDispatch()
  const history = useHistory();
  const [title,desc,reference] = [
    useRef(""),
    useRef(""),
    useRef("")
  ];
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setProjects(projects))
    history.push("/add-interests");
  }
  function addProject(e){
    e.preventDefault();
    setResumeProjects((prevProjects)=>{
      return [...prevProjects,{title:title.current.value,desc:desc.current.value,reference:reference.current.value}]
    })
  }
  function removeProject(id){
    setResumeProjects((prevProjects)=>{
      return prevProjects.filter((project,index)=>index!==id)
    })
  }
  useEffect(()=>{
    title.current.value=''
    desc.current.value=''
    reference.current.value=''
  },[projects])
  return (
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <h1><i class="mr-2 fas fa-tasks"></i>Project Details</h1>
        <form onSubmit={addProject}>
          <input type="text" ref={title} placeholder="Project title" required />
          <input
            type="text"
            ref={desc}
            placeholder="Description"
            required
          />
          <input type="url" ref={reference} placeholder="Reference url eg. 'https://gdresume.herokuapp.com'" required />
          <motion.button variants={linkVariant} whileHover="hover" type="submit">add</motion.button>
        </form>
        <ul>
          {projects.map((project,index)=>{
            return (<Project project={project} key={index} id={index} removeProject={removeProject} />)
          })}
        </ul>
        {projects==0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>no projects</motion.button>}
        {projects!=0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>save & next</motion.button>}

      </motion.div>
    </motion.div>
  );
}
